import { Incentive } from '@amzn/atoz-shiftapp-types';
import { durationToHours, getWeekIntervalString, formatHoursAndMinutesFromKey } from '@amzn/atoz-shiftapp-utilities';
import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';
import { countWorkHoursInWeek } from './utils';
export var useWeeklySummaryData = function (_a) {
    var weekProgress = _a.weekProgress, incentives = _a.incentives, hideProgress = _a.hideProgress, scheduledShifts = _a.scheduledShifts, targetWeek = _a.targetWeek;
    var t = useTranslation().t;
    var maxDuration = weekProgress
        ? durationToHours(weekProgress.maxDuration.value)
        : scheduledShifts && targetWeek
            ? 1
            : undefined;
    var workedDuration = weekProgress
        ? durationToHours(weekProgress.workedDuration.value)
        : undefined;
    var upcomingScheduledDuration = weekProgress
        ? durationToHours(weekProgress.upcomingScheduledDuration.value)
        : undefined;
    var eligibleDuration = weekProgress
        ? durationToHours(weekProgress.eligibleDuration.value)
        : undefined;
    var scheduledDuration = scheduledShifts && targetWeek
        ? countWorkHoursInWeek(scheduledShifts, targetWeek)
        : (workedDuration || 0) + (upcomingScheduledDuration || 0);
    var ariaLabel = "".concat(t('ess_shifts_dashboard_weeklySummary_yourWeek'), " ").concat(targetWeek
        ? getWeekIntervalString(targetWeek.start)
        : getWeekIntervalString(DateTime.local()), ", ").concat(maxDuration).concat(t('ess_shifts_dashboard_weeklySummary_hoursMax'), ", ").concat(scheduledDuration).concat(t('ess_shifts_dashboard_weeklySummary_hoursScheduled'));
    var isGoldEligible = !!(incentives === null || incentives === void 0 ? void 0 : incentives.includes(Incentive.GoldEligible));
    var isGold = !!(incentives === null || incentives === void 0 ? void 0 : incentives.includes(Incentive.Gold));
    var displayProgress = !hideProgress && !!maxDuration && workedDuration != null;
    var getHoursScheduledHoursString = function () {
        return formatHoursAndMinutesFromKey('ess_shifts_dashboard_weeklySummary_hoursScheduled', scheduledDuration);
    };
    var progressBarPrimaryLabel = getHoursScheduledHoursString();
    var progressBarSecondaryLabel = eligibleDuration
        ? formatHoursAndMinutesFromKey('ess_shifts_dashboard_weeklySummary_hoursLeft', eligibleDuration)
        : undefined;
    return {
        maxDuration: maxDuration || 0,
        scheduledDuration: scheduledDuration,
        eligibleDuration: eligibleDuration,
        ariaLabel: ariaLabel,
        isGoldEligible: isGoldEligible,
        isGold: isGold,
        displayProgress: displayProgress,
        progressBarPrimaryLabel: progressBarPrimaryLabel,
        progressBarSecondaryLabel: progressBarSecondaryLabel
    };
};
